import { useCallback, useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import validate from './validationPlan'
export default (onSuccess, onError) => {
  const [mutation, { data, error, loading }] = useMutation(
    gql`mutation createPaymentItemFromAdmin(
        $planId: ID!,
        $paymentInput: EditPlanPaymentItem!
    ){
        editPlanPaymentItemFromAdmin(planId: $planId, paymentInput: $paymentInput){
            id
        }
      }`
  )
  const [validationErrors, setValidationErrors] = useState({})
  const submit = useCallback((obj) => {
    const errors = validate(obj)
    if (errors && Object.keys(errors).length) {
      setValidationErrors(errors)
      onError('validation Error', errors)
      return
    }
    mutation({ variables: obj }).then((result) => {
      onSuccess(result)
    }).catch((e) => {
      setValidationErrors({ general: 'misc.apiError' })
      onError(e)
    })
  }, [mutation, onSuccess, onError])
  return { loading, data: data ? data.editPlanPaymentItemFromAdmin : null, error, validationErrors, submit }
}
